<template>
  <div>
    <div class="form-request">

      <div :class="typeMessage" role="alert" v-if="message != ''">
        {{message}}
      </div>

      <template v-if="!no_laboral_experience">

        <template v-if="!done">

          <div class="content-tab">
            <p id="title-forms" class="title-step">Cuéntanos sobre tus trabajos anteriores o actuales (recuerda informarnos si nos autorizas a contactar a la empresa en la que trabajas actualmente).</p>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <input class="custom-control-input" id="customCheck1" type="checkbox" v-model="no_laboral_experience">
              <label class="custom-control-label myLabelTabs" for="customCheck1">No cuento con experiencia laboral</label>        
            </div>
          </div>

          <div class="container">
            <div class="row">
              <div class="col d-flex justify-content-center">
                <div class="row attachments-files">
                  <div class="col-sm-12 attachs-content">
                    <div class="col-sm-12">
                      <div class="col-sm-3 icon-upload">
                        <label for="file_document" id="label-upload"><img src="https://res.cloudinary.com/dhcti0lrk/image/upload/v1602709289/Group_122_pzjifh.png" alt="" class="img-upload" /></label>
                      </div>
                      <div class="col-sm-9">
                        <p class="myLabel">Certificado laboral.</p>
                        <p id="uploadInstruction">Archivos permitidos: PDF, DOC, DOCX, Imágenes, etc.</p>
                        <input type="file" class="input-upload" :id="`file_certificate_candidate`" :ref="`file_certificate_candidate`" multiple v-on:change="handleFilesUpload()"> 
                      </div>
                    </div>
                    <div class="col-sm-12" v-if="certifieds.length > 0">
                      <p class="myLabel">Archivos subidos: {{certifieds.length}}</p>
                      <ul>
                        <li v-for="certified in certifieds" :key="certified.id">
                          <template v-if="certified != null">
                            <a
                              :href="normalizeSecureFileUrl(certified.url)"
                              class="myLabel"
                              target="_blank"
                              @click.prevent="openSecureFileUrl(certified.url, { resourceType: 'project_archive', id: certified.id })"
                            >{{certified.name.substring(0,40)}}</a>
                            <button @click.prevent="deleteArchive(certified.id)" type="button" class="buttonDeleteFile"><i class="far fa-trash-alt"></i></button>
                          </template>
                        </li>
                      </ul>          
                    </div>                                                                
                  </div>         
                </div>
              </div>
            </div>
          </div>      

          <div class="row">
            <div class="col-sm-6">
              <p class="myLabelTabs" >Empresa</p>
              <input class="inputRequest" type="text" v-model="laboral_reference.company_name">
            </div>

            <div class="col-sm-6">
              <p class="myLabelTabs" >Cargo</p>
              <input class="inputRequest" type="text" v-model="laboral_reference.charge">
            </div>      

            <div class="col-sm-6">
              <p class="myLabelTabs" >Nombre contacto</p>
              <input class="inputRequest" type="text" v-model="laboral_reference.contact_name">
            </div>

            <div class="col-sm-6">
              <p class="myLabelTabs" >Cargo contacto</p>
              <input class="inputRequest" type="text" v-model="laboral_reference.contact_charge">
            </div>

            <div class="col-sm-6">
              <p class="myLabelTabs" >Email contacto</p>
              <input class="inputRequest" type="text" v-model="laboral_reference.email">
            </div>

            <div class="col-sm-6">
              <p class="myLabelTabs" >Teléfono contacto</p>
              <input class="inputRequest" type="text" v-model="laboral_reference.contact_telephone">
            </div>                        

            <div class="col-sm-4">
              <p class="myLabelTabs" >Fecha inicial</p>
              <input class="select-request" type="date" v-model="laboral_reference.start_at">        
            </div>

            <div class="col-sm-3 row-check">
              <input class="custom-control-input" id="customCheck1" type="checkbox" v-model="laboral_reference.current_work">
              <label class="custom-control-label myLabelTabs" for="customCheck1">Actualmente trabajo acá</label>
            </div>      

            <div class="col-sm-3 row-check" v-if="laboral_reference.current_work">
              <input class="custom-control-input" id="customCheck1" type="checkbox" v-model="laboral_reference.authorize_contact">
              <label class="custom-control-label myLabelTabs" for="customCheck1">¿Autoriza contactar esta referencia?</label>
            </div>            

            <div class="col-sm-4" v-else>
              <p class="myLabelTabs" >Fecha final</p>
              <input class="select-request" type="date" v-model="laboral_reference.leave_at">        
            </div>                  
          </div>

          <div class="row">
            <div class="col-sm-4">
              <b-button class="button-save button-form-steps" @click.prevent="save">{{textButton}}</b-button>
            </div>      
          </div>
        </template>

        <div class="content-tab" v-else>
          <p id="title-forms" class="title-step">La información ha sido diligenciada</p>
        </div>

        <table class="table table-condensed" id="table-academic-references" v-if="width > 768">
          <thead>
              <tr>
                <th class="header-column-table">Empresa</th>
                <th class="header-column-table">Cargo</th>
                <th class="header-column-table">Nombre contacto</th>
                <th class="header-column-table">Cargo contacto</th>
                <th class="header-column-table">Email contacto</th>
                <th class="header-column-table">Teléfono</th>
                <th class="header-column-table">Fecha inicial</th>
                <th class="header-column-table">Fecha final</th>
                <th class="header-column-table">Trabajo actual</th>
                <th class="header-column-table">Autoriza contacto</th>
                <th class="header-column-table" v-if="!done">Editar</th>
                <th class="header-column-table" v-if="!done">Eliminar</th>
              </tr>
          </thead>
          <tbody>
            <tr v-for="laboral_reference_iterator in laboral_references_local" :key="laboral_reference_iterator.id">
              <td class="myLabelTabs">{{laboral_reference_iterator.company_name}}</td>
              <td class="myLabelTabs">{{laboral_reference_iterator.charge }}</td>
              <td class="myLabelTabs">{{laboral_reference_iterator.contact_name }}</td>
              <td class="myLabelTabs">{{laboral_reference_iterator.contact_charge}}</td>
              <td class="myLabelTabs">{{laboral_reference_iterator.email}}</td>
              <td class="myLabelTabs">{{laboral_reference_iterator.contact_telephone}}</td>
              <td class="myLabelTabs">{{laboral_reference_iterator.start_at}}</td>
              <td class="myLabelTabs">{{laboral_reference_iterator.leave_at}}</td>
              <td class="myLabelTabs grid-center">
                <p v-if="laboral_reference_iterator.current_work">Si</p>
                <p v-else>No</p>
              </td>
              <td class="myLabelTabs grid-center">
                <p v-if="laboral_reference_iterator.authorize_contact">Si</p>
                <p v-else>No</p>
              </td>            
              <td v-if="!done">
                <button @click.prevent="edit(laboral_reference_iterator)" type="button" class="mybuttonAction"><i class="far fa-edit"></i></button>
              </td>            
              <td v-if="!done">
                <button @click.prevent="deleteLaboralReference(laboral_reference_iterator)" type="button" class="mybuttonAction"><i class="far fa-trash-alt"></i></button>
              </td>            
            </tr>
          </tbody>
        </table>
        <ul class="list-group" v-else v-for="laboral_reference_iterator in laboral_references_local" :key="laboral_reference_iterator.id">
          <li class="list-group-item active header-list">
            {{laboral_reference_iterator.company_name}}
          </li>
          <li class="list-group-item item-list">Cargo: {{laboral_reference_iterator.charge }}</li>
          <li class="list-group-item item-list">Nombre contacto: {{laboral_reference_iterator.contact_name }}</li>
          <li class="list-group-item item-list">Cargo contacto: {{laboral_reference_iterator.contact_charge}}</li>
          <li class="list-group-item item-list">Email contacto: {{laboral_reference_iterator.email}}</li>
          <li class="list-group-item item-list">Teléfono: {{laboral_reference_iterator.contact_telephone}}</li>
          <li class="list-group-item item-list">Fecha inicial: {{laboral_reference_iterator.start_at}}</li>
          <li class="list-group-item item-list">Fecha final: {{laboral_reference_iterator.leave_at}}</li>
          <li class="list-group-item item-list" v-if="!done">
            <div class="btn-group" role="group" aria-label="Basic example">
              <button @click.prevent="edit(laboral_reference_iterator)" type="button" class="button-save"><i class="far fa-edit"></i>Editar</button>
              <button @click.prevent="deleteLaboralReference(laboral_reference_iterator)" type="button" class="button-save"><i class="far fa-trash-alt"></i>Eliminar</button>              
            </div>            
          </li>
        </ul>                
      </template>

    </div>
  </div>
</template>

<script>
import axios from "axios";
import { eventBus } from './../../../application'
import secureFiles from '../../../mixins/secureFiles'
export default {
  name: "AcademicForm",
  mixins: [secureFiles],
  props: ['project', 'assignments', 'cities', 'laboral_references'],
  data() {
    return {
      width: null,
      typeMessage: '',
      message: '',
      laboral_references_local: this.laboral_references,
      laboral_reference: { current_work: false, authorize_contact: true },
      token: null,
      textButton: 'Agregar',
      no_laboral_experience: false,
      files: '',
      certifieds: [],
      assignment_types: [3, 9, 10],
      done: false      
    };
  },
  methods: {
    async deleteArchive(archiveId) {
      this.setHeaders()
      let request = await axios.delete( `/delete_file_of_project?archive_id=${archiveId}`)
      if (request.status == 200) {
        this.showMessage(`Archivo eliminado con éxito`, 'alert-success', 7000)
        this.getArchives()
      }        
    },    
    async getArchives(){
      let request = await axios.get(`/get_laboral_certifieds?project_id=${this.project.id}&laboral_reference_id=${this.laboral_reference.id}`)
      if (request.status == 200) {
        this.certifieds = request.data.certifieds
      }
    },    
    async submitFiles(laboralReferenceId){
      this.setHeaders()
      let formData = new FormData();
      for( var i = 0; i < this.files.length; i++ ){
        let file = this.files[i];
        formData.append('files[' + i + ']', file);
      }
      let request = await axios.put( `/upload_work_certificate?project_id=${this.project.id}&laboral_reference_id=${laboralReferenceId}&type_document=work_certificate`, formData)
      this.files = ''
    },    
    handleFilesUpload() {
      this.files = this.$refs[`file_certificate_candidate`].files;
    },
    setHeaders () {
      const token = document.querySelector('meta[name="csrf-token"]').getAttribute("content")
      axios.defaults.headers["x-csrf-token"] = token
      axios.defaults.headers.common["Accept"] = "application/json"
      axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest"
    },
    getNameCity(city_id) {
      let city = this.cities.find( city => city.id == city_id)
      if (city != null) {
        return city.name
      } else {
        return ''
      }      
    },
    async save() {
      this.laboral_reference.project_id = this.project.id
      let str = /[^0-9]/g;
      this.laboral_reference.contact_telephone = this.laboral_reference.contact_telephone.replace(str, '')
      this.setHeaders()
      if (this.laboral_reference.id != null) { // put
        let request = await axios.put(`/api/v1/update_laboral_references_origin_candidate/${this.laboral_reference.id}?token=${this.token}`, { laboral_reference: this.laboral_reference })
        if (request.status == 200) {
          this.submitFiles(this.laboral_reference.id)
          this.showMessage('Referencia académica editada con exito', 'alert-success')
          this.laboral_reference = { current_work: false, authorize_contact: true }
        } else {
          this.showMessage('No se pudo editar la referencia académica', 'alert-danger')
        }
      } else { // post
        let request = await axios.post(`/api/v1/create_laboral_references_origin_candidate?token=${this.token}`, { laboral_reference: this.laboral_reference })
        if (request.status == 201) {
          if (this.files != '') this.submitFiles(request.data.id)
          this.showMessage('Referencia académica creada con exito', 'alert-success')
          this.laboral_references_local.push(request.data)
          this.laboral_reference = { current_work: false, authorize_contact: true }

        } else {
          this.showMessage('No se pudo crear la referencia académica', 'alert-danger')
        }
      }
      this.certifieds = []
    },
    async deleteLaboralReference (laboral_reference) {
      const url = `/api/v1/delete_laboral_references_origin_candidate/${laboral_reference.id}?token=${this.token}`
      this.setHeaders()
      let request = await axios.delete(url)
      if (request.status == 200) {
        this.laboral_references_local = this.laboral_references_local.filter( laboral_reference_iterator => laboral_reference_iterator.id != laboral_reference.id )
        this.showMessage('Referencia académica eliminada con exito', 'alert-success')
      } else {
        this.showMessage('No se pudo eliminar la referencia académica', 'alert-danger')
      }
    },
    edit (laboral_reference) {
      this.laboral_reference = laboral_reference
      this.getArchives()
    },
    showMessage(message, typeMessage){
      this.message = message
      this.typeMessage = `alert ${typeMessage}`
      setTimeout(() => this.message = '', 3000)
    },     
    setTextButton(){
      if (this.laboral_reference.id != null){
        this.textButton = 'Editar'
      } else {
        this.textButton = 'Agregar'
      }
    }
  },
  watch: {
    laboral_reference() {
      this.setTextButton()
    }
  },
  created () {
    let token = window.location.search.split('token=')[1]
    if (token != null) {
      this.token = token
    }
    eventBus.$on('authorizeNextTabLaboral', dataPassed => {
      if (this.laboral_references_local.length >= 1 || this.no_laboral_experience) {
        eventBus.$emit('goToNextTab')
      } else {
        this.showMessage('Debe ingresar mínimo dos referencias', 'alert-warning')
      }
    })    
  },
  mounted () {
    this.assignment_types.forEach(assignment_type_id => {
      let assignment = this.assignments.filter( assignment => assignment.assignment_type_id == assignment_type_id )[0]
      if (assignment != null) {
        if (assignment.status == 4) {
          this.done = true
        } 
        return
      }
    });            
    this.width = screen.width
  },
};
</script>

<style></style>
